import { createContext, useContext } from 'react';
import type { EngineSource, EntitySuggestion } from '@/types';
import { ENGINE_COLOR_CONFIG } from '@/types';

export interface TesterModeContextValue {
  isTesterMode: boolean;
  enabledEngines: Set<EngineSource>;
  toggleEngine: (engine: EngineSource) => void;
  filterSuggestions: (suggestions: EntitySuggestion[]) => EntitySuggestion[];
}

export const ALL_ENGINES = new Set(Object.keys(ENGINE_COLOR_CONFIG) as EngineSource[]);

export const TesterModeContext = createContext<TesterModeContextValue>({
  isTesterMode: false,
  enabledEngines: ALL_ENGINES,
  toggleEngine: () => {},
  filterSuggestions: (s) => s,
});

export function useTesterMode() {
  return useContext(TesterModeContext);
}
